import React from "react";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import TitleSection from "../../../components/molecules/title-section";
import Button from "../../atoms/button/button";
import "./connect-to-lider.scss";
import { Link } from "gatsby";

const ConectaRedLideres = (props: ReferenciaContenido) => {
    const { tituloGeneral, descripcion, tituloBoton, redireccionBoton } = props;

    return (
        <>
            <div className="m-cmnd-banner-red conecta-red">
                <div>
                    <TitleSection
                        title={tituloGeneral}
                        introText={descripcion.json.content[0].content[0].value}
                    />
                </div>
                <div className="button-wrapper">
                    <Link to={redireccionBoton}>
                        <Button
                            type="link"
                            text={tituloBoton}
                            classname="a-button__magenta gtm_ingresa_al_foro_home_comunidades"
                            href={void(0)}
                            isDisabled={false}
                        />
                    </Link>
                </div>
            </div>
        </>
    );
}

export default ConectaRedLideres;
